export default "__VITE_ASSET__csSXPXMU__"